//
// Copyright (c) 2011-2017 by Curalate, inc.
//

/* global angular: false, _: false */

(function() {
  const curalate = angular.module('curalate');

  curalate.directive('widgetEmbedCodeModal', () => {
    return {
      restrict: 'E',
      transclude: 'true',
      scope: {
        embedCode: '=',
        widgetId: '=',
        close: '&',
      },
      template: require('@legacy-components/common/widgets/widget-embed-code-modal.html'),
      link() {
                    // When the user clicks on the embed code text in the modal,
                    // we'll automatically select all of the text for them. Note
                    // that we unbind mouseup here because Chrome will deselect
                    // text on mouseup after the focus event fires.
        angular.element('.widget-embed-code-container').focus(function() {
          const elem = angular.element(this);
          elem.select();
          elem.mouseup(() => {
            elem.unbind('mouseup');
            return false;
          });
        });
      },
      controller: ['$scope', '$window',
        function($scope, $window) {
          const SHOP_BUTTON_DEFAULT_TEXT = 'SHOP';
          const BASE_PREVIEW_URL = `${crl8.session.baseUrls.reveal_v1}/`;

          $scope.model = {
            embedCode: $scope.embedCode.trim(),
            settings: {
              autoShowProducts: false,
              shopButtonText: SHOP_BUTTON_DEFAULT_TEXT,
              stretchToFit: false,
              activeProductIcon: 'tag',
            },
            defaults: {
              shopButtonText: SHOP_BUTTON_DEFAULT_TEXT,
            },
            close() { $scope.close({ result: true }); },
          };

                    // Allow the user to preview their currently configured Reveal. We'll
                    // open a new window pointing to a dedicated preview page
          $scope.model.openPreviewWindow = function() {
            const previewWindowUrl = `${BASE_PREVIEW_URL + $scope.widgetId}/preview` +
                                `?autoShowProducts=${$scope.model.settings.autoShowProducts
                                }&stretchToFit=${$scope.model.settings.stretchToFit
                                }&shopButtonText=${$scope.model.settings.shopButtonText
                                }&activeProductIcon=${$scope.model.settings.activeProductIcon}`;
            $window.open(previewWindowUrl);
          };

                        // Parse the supplied embedCode string and make it configurable. For
                        // example, we have a checkbox for autoShowProducts. When the value
                        // of the checkbox is updated, we update the string to reflect that.
          $scope.model.settings.updateAutoShowProductsSetting = function() {
            $scope.model.embedCode = $scope.model.embedCode.replace(
                                /data-auto-show-products="(false|true)"/,
                                `data-auto-show-products="${$scope.model.settings.autoShowProducts}"`,
                            );
          };

          $scope.model.settings.updateActiveProductIconSetting = function() {
            $scope.model.settings.activeProductIcon = $scope.model.settings.activeProductIcon.replace(/"/g, "'");
            $scope.model.embedCode = $scope.model.embedCode.replace(
                                /data-active-product-icon=".*?"/,
                                `data-active-product-icon="${$scope.model.settings.activeProductIcon}"`,
                            );
          };

          $scope.model.settings.updateShopButtonTextSetting = function() {
            $scope.model.settings.shopButtonText = $scope.model.settings.shopButtonText.replace(/"/g, "'");
            $scope.model.embedCode = $scope.model.embedCode.replace(
                                /data-shop-button-text=".*?"/,
                                `data-shop-button-text="${$scope.model.settings.shopButtonText}"`,
                            );
          };

          $scope.model.settings.updateStretchToFitSetting = function() {
            $scope.model.embedCode = $scope.model.embedCode.replace(
                                /data-stretch-to-fit="(false|true)"/,
                                `data-stretch-to-fit="${$scope.model.settings.stretchToFit}"`,
                            );

            $scope.model.embedCode = $scope.model.embedCode.replace(
                                / width: (auto|100%) !important/,
                                ` width: ${$scope.model.settings.stretchToFit ? '100%' : 'auto'} !important`,
                            );
          };
        },
      ],
    };
  },
    );
})();
